import { getGroupAuthType } from "@/utils/authToken";
import { httpAuth } from "@/api/httpAuth";

import { GROUP_AUTH_HEADER_NAME } from "../constants";

export const surveyRequests = {
  check_survey: async ({ context, data } = {}) => {
    return httpAuth
      .post("/v1/survey/check_nps_survey", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
  submit_survey: async ({ context, data } = {}) => {
    return httpAuth
      .post("/v2/survey/nps_survey", {
        context,
        headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
        json: data,
      })
      .json();
  },
};
